import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[dbStopPinchEvent]',
  standalone: true
})
export class StopPinchEventDirective {

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (event['wheelDeltaY'] === 0) {
      event.preventDefault();
      return;
    }

    event.stopPropagation();
  }

}
